import { store } from '@betacrew/jars-flux';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import OnboardingDataService from '../../../services/OnboardingDataService';
import { TOASTER_VARIANT } from '../../components/toast/constants';
import { GENERIC_ERROR_MESSAGE, PAGE_STATE } from '../constants/constants';
import { addNotifications } from '../toaster/ToasterPortalSlice';
import { ONBOARDING_LOADING_STATES } from './constants';
import { componentKey, setLoadingState, setOnboardingFormOptionsData } from './OnboardingSlice';
import { setSignedInUser } from '../authentication/AuthenticationSlice';
import UserDataService from '../../../services/UserDataService';
import { setErrorInProfile } from '../dashboard/DashboardSlice';

export const { saveOnboardingData, getOnboardingFormOptions } = {
    saveOnboardingData: (payload) => {
        return {
            type: "ONBOARDING/UPDATE_DATA",
            payload: payload
        }
    },
    getOnboardingFormOptions: (payload) => {
        return {
            type: "ONBOARDING/FORM_OPTIONS",
            payload: payload
        }
    },
}

function* saveOnboardingDataAsync(action){
    try {
        const {onboardingDataToSave, goToNextScreenCb, nextScreenStateValue} = action.payload;
        yield put(setLoadingState({ state: ONBOARDING_LOADING_STATES.SAVE_ONBOARDING_ACTION_LOADING }));
        const response = yield OnboardingDataService.saveOnboardingData(onboardingDataToSave);
        if(response?.data){
            if(response?.data?.Status === 0){
                let concatenatedErrorMessages = '';

                for (const key in response?.data?.Data) {
                    if (response?.data?.Data.hasOwnProperty(key)) {
                        const messages = response?.data?.Data[key];
                        const formattedMessages = messages.map((message) => `<li>${message}</li>`).join('<br>');
                        concatenatedErrorMessages += `<strong>${key}:</strong><ul>${formattedMessages}</ul>`;
                    }
                }
                yield put(addNotifications({
                    heading: "Error",
                    message: concatenatedErrorMessages,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }else{
                yield put(goToNextScreenCb(nextScreenStateValue));
                if (!nextScreenStateValue) {
                    const profileResponse = yield UserDataService.getProfile();
                    if (profileResponse?.data) {
                        if (profileResponse.data?.Status === 0) {
                            yield put(setErrorInProfile(true))
                            yield put(addNotifications({
                                heading: "Error",
                                message: profileResponse?.data?.Message,
                                variant: TOASTER_VARIANT.DANGER
                            }));
                        } else {
                            let userProfileData = profileResponse?.data?.Data;
                            yield put(setSignedInUser(userProfileData))
                        }
                    }
                }
            }
        }
    } catch(error) {
        console.log("error: ", error)
        yield put(addNotifications({
            heading: "Error",
            message: GENERIC_ERROR_MESSAGE,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: ONBOARDING_LOADING_STATES.SAVE_ONBOARDING_ACTION_READY }));
    }
}

function* getOnboardingFormOptionsAsync(action) {
    try {
        yield put(setLoadingState({ state: ONBOARDING_LOADING_STATES.ONBOARDING_PAGE_LOADING }));
        const response = yield OnboardingDataService.getSignUpFormOptions();
        if(response?.data){
            if(response?.data?.Status === 0){
                yield put(addNotifications({
                    heading: "Error",
                    message: "Error in fetching form options",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }else{
                yield put(setOnboardingFormOptionsData(response?.data?.Data));
            }
        }
    } catch(error) {
        console.log("error: ", error)
        yield put(addNotifications({
            heading: "Error",
            message: GENERIC_ERROR_MESSAGE,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: ONBOARDING_LOADING_STATES.ONBOARDING_PAGE_READY }));
    }
}

function* rootSaga() {
    yield all([
        takeLatest(saveOnboardingData().type, saveOnboardingDataAsync),
        takeLatest(getOnboardingFormOptions().type, getOnboardingFormOptionsAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);